<template>
  <span class="showPayIcon-container" v-if="cardInfo" :class="[cardInfo?.cardType, cardInfo?.walletType]">
    <bk-image v-if="url" :src="url"></bk-image>
    <span v-if="cardInfo.last4">
      <span style="position: relative;top: 4px;">****&nbsp;</span>
      <span>{{ cardInfo.last4 }}</span>
    </span>
		<span v-else-if="cardInfo.appWalletAccount">{{ cardInfo.appWalletAccount }}</span>
  </span>
</template>

<script>
	export default {
		name:'showPayIcon',
		props:{
			cardInfo:Object
		},
		computed:{
			url (){
				const { baseImgUrl, } =this.$bk_Global;
				let { cardType, walletType } = this.cardInfo || {};

				let obj = {
					visa:'Def_ReservePay_visa.png?v=1',
					mastercard:'Def_ReservePay_mastercard.png',
					link:'Def_ReservePay_link.png',
					def:'Def_ReservePay_def.png',
				};

				if(walletType==='LINK'){
					cardType = 'link';
				}
        
				return `${baseImgUrl}${obj[cardType] || obj['def']}`;
			}
		}
	};
</script>

<style lang="less">
@import './showPayIcon.less';
</style>